import React, { useState, useCallback } from "react";
import { debounce } from "lodash";

const Searchbar = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((queryText) => {
      onSearch(queryText);
    }, 300),
    [onSearch]
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const queryText = e.target.value;
    setSearchQuery(queryText);
    debouncedSearch(queryText);
  };

  // Clear search results
  const handleClearSearch = () => {
    setSearchQuery("");
    onSearch("");
  };

  return (
    <div className="bg-white py-6 px-4 lg:px-16 shadow-sm">
      <div className="relative max-w-2xl mx-auto">
        <input
          type="text"
          placeholder="Search for your drug here..."
          value={searchQuery}
          onChange={handleSearchChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="w-full p-4 pl-12 pr-12 rounded-xl text-gray-800 placeholder-gray-400 
                   focus:outline-none shadow-sm border border-gray-200 
                   focus:border-green-400 focus:ring-2 focus:ring-green-100 
                   transition-all duration-200"
          aria-label="Search for drugs"
        />
        
        {/* Search Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`w-5 h-5 absolute top-1/2 left-4 transform -translate-y-1/2 transition-colors duration-200 ${
            isFocused ? "text-green-500" : "text-gray-400"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        
        {/* Clear Button */}
        {searchQuery && (
          <button
            onClick={handleClearSearch}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 
                     text-gray-400 hover:text-red-400 focus:outline-none 
                     transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
            aria-label="Clear search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Searchbar;